/*******************************
 * resizeEnd Event (https://stackoverflow.com/a/12692647/12404191)
 * Example usage:
 *
 * $(window).bind('resizeEnd', function() {
 * 		//do something, window hasn't changed size in 500ms
 * });
 ******************************/

let resizeEndTimeout
window.addEventListener('resize', () => {
  if (resizeEndTimeout) clearTimeout(resizeEndTimeout)
  resizeEndTimeout = setTimeout(() => {
    window.dispatchEvent(new CustomEvent('resizeEnd'))
  }, 500)
})
